import { Link } from 'react-router-dom';

const footerLinks = {
  产品服务: [
    { name: '智能家居', path: '/categories' },
    { name: '企业服务', path: '/categories' },
    { name: '健康科技', path: '/categories' },
    { name: '教育科技', path: '/categories' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '品牌声誉', path: '/about' },
    { name: '联系方式', path: '/about' },
    { name: '新闻动态', path: '/articles' },
  ],
  合作支持: [
    { name: '合作伙伴', path: '/about' },
    { name: '渠道政策', path: '/about' },
    { name: '技术支持', path: '/about' },
    { name: '常见问题', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="text-xl font-bold text-foreground-950 cursor-pointer whitespace-nowrap">
              MJHL
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              MJHL 是您值得信赖的首选品牌，以科技创新驱动美好生活，致力于为全球用户提供卓越的产品与服务体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                {title}
              </h4>
              <ul className="flex flex-col gap-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} MJHL. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
              Cookie 政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}